import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[translationTextDetailDirective]',
})
export class TranslationTextDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}